<template>
  <div>
    <Header></Header>
    <div class="main">
      <div class="top-loc center">
        <div class="current-loc">
          <span>{{ $t('satellite.CurrentPosition') }}：</span>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">{{ $t('satellite.Home') }}</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/satelliteData' }">{{
                $t('satellite.SatelliteData')
              }}
            </el-breadcrumb-item>
            <el-breadcrumb-item>{{ productVo && productVo.productAlias }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div class="black-bg">
        <div class="info">
          <p class="name">
            {{ productVo && productVo.productAlias }}
          </p>
          <p class="label">
            <span>{{ $t('satellite.ReleaseTime') }}：{{ productVo && productVo.startTime }}</span>
            <span style="margin:0 24px">{{ $t('satellite.Views') }}：{{ productVo && productVo.dataGlanced }}</span>
            <span>{{ $t('satellite.Downloads') }}：{{ productVo && productVo.downloads }}</span>
          </p>

          <div class="basic-info">
            <p class="title-p">
              <svg t="1638238784344" class="icon" viewBox="0 0 1024 1024" version="1.1"
                   xmlns="http://www.w3.org/2000/svg" p-id="12020" width="16" height="16">
                <path
                    d="M252.16 0m81.371429 0l356.937142 0q81.371429 0 81.371429 81.371429l0 55.588571q0 81.371429-81.371429 81.371429l-356.937142 0q-81.371429 0-81.371429-81.371429l0-55.588571q0-81.371429 81.371429-81.371429Z"
                    p-id="12021" fill="#0269FF"></path>
                <path
                    d="M822.857143 120.32h-9.508572v22.674286c0 64.365714-47.36 116.845714-105.508571 116.845714H316.342857c-58.148571 0-105.508571-52.48-105.508571-116.845714V120.32H201.142857a103.862857 103.862857 0 0 0-103.497143 104.228571v694.857143A103.862857 103.862857 0 0 0 201.142857 1024h621.714286a103.862857 103.862857 0 0 0 103.497143-104.228571v-694.857143A103.862857 103.862857 0 0 0 822.857143 120.32z m-555.702857 283.428571H493.714286a37.668571 37.668571 0 0 1 0 75.337143H267.154286a37.668571 37.668571 0 0 1 0-75.337143z m489.691428 468.662858H267.154286a37.668571 37.668571 0 0 1 0-75.337143h489.691428a37.668571 37.668571 0 1 1 0 75.337143z m0-196.754286H267.154286a37.668571 37.668571 0 1 1 0-75.154286h489.691428a37.668571 37.668571 0 1 1 0 75.154286z"
                    p-id="12022" fill="#0269FF"></path>
              </svg>
              {{ $t('satellite.BasicInformation') }}
            </p>
            <hr>
            <p class="basic-info-site">
              <span class="s1"><span class="s-name">{{
                  $t('satellite.DatasetName')
                }}:</span>{{ productVo && productVo.productAlias }}</span>
            </p>
            <p class="basic-info-site">
              <span class="s1"><span class="s-name">{{
                  $t('satellite.Resource')
                }}:</span>{{ productVo && productVo.productProvider }}</span>
              <span class="s2"><span class="s-name">{{
                  $t('satellite.Satellite')
                }}:</span>{{ productVo && productVo.satelliteName }}</span>
              <span class="s3"><span class="s-name">{{
                  $t('satellite.Sensor')
                }}:</span>{{ productVo && productVo.sensorName }}</span>
            </p>
            <p class="basic-info-site">
              <span class="s1"><span class="s-name">{{
                  $t('satellite.ProductLevel')
                }}:</span>{{ productVo && productVo.productLevel }}</span>
              <span class="s2"><span class="s-name">{{
                  $t('satellite.Resolution')
                }}:</span>{{ productVo && productVo.productResolution }}</span>
              <span class="s3"><span class="s-name">{{
                  $t('satellite.Format')
                }}:</span>{{ productVo && productVo.productFormat }}</span>
            </p>
            <p class="basic-info-site">
              <span class="s1"><span class="s-name">{{ $t('satellite.TimeSpan') }}:</span>{{ this.dateSpan }}</span>
              <span class="s2"><span class="s-name">{{ $t('satellite.LatestTime') }}:</span>{{
                  this.dateInterval
                }}</span>
              <span class="s3"><span class="s-name">{{ $t('satellite.Entry') }}:</span>{{
                  productVo && productVo.count
                }}</span>
            </p>
            <p class="basic-info-site">
              <span class="s1"><span class="s-name">{{
                  $t('satellite.DataVolume')
                }}:</span>{{ productVo && byte2Auto(productVo.spaceUsage) }}</span>
              <span class="s2"><span class="s-name">{{
                  $t('satellite.SharedScope')
                }}:</span>{{ productVo && productVo.productShareScope }}</span>
              <span class="s3"><span class="s-name">{{
                  $t('satellite.CoverageArea')
                }}:</span>{{ productVo && productVo.productCoverage }}</span>
            </p>
            <p class="basic-info-site" v-if="productVo.showDataScope==='Y'">
              <span class="s1"><span class="s-name">{{ $t('satellite.FullDataCoverage') }}:</span><el-tag size="mini"
                                                                                                          style="cursor:pointer;"
                                                                                                          @click="showDataCover = true">{{
                  $t('product.ClicktoView')
                }}</el-tag></span>
            </p>
            <el-dialog
                :title="$t('product.warning')"
                :visible.sync="showDataCover"
                width="50%"
                class="thisblack-bgc"
                :modal="false"
                center>
              <div class="alldatarange" v-loading="loadingRange" id="alldatarange"></div>
              <p style="text-align: right;margin-top: 10px">{{
                  $t('cloudComputing.Mapsource')
                }}：{{ $t('cloudComputing.Tianditu') }}</p>
            </el-dialog>
          </div>
          <div class="basic-info" style="margin:10px 0;">
            <p class="title-p">
              <svg t="1638238784344" class="icon" viewBox="0 0 1024 1024" version="1.1"
                   xmlns="http://www.w3.org/2000/svg" p-id="12020" width="16" height="16">
                <path
                    d="M252.16 0m81.371429 0l356.937142 0q81.371429 0 81.371429 81.371429l0 55.588571q0 81.371429-81.371429 81.371429l-356.937142 0q-81.371429 0-81.371429-81.371429l0-55.588571q0-81.371429 81.371429-81.371429Z"
                    p-id="12021" fill="#0269FF"></path>
                <path
                    d="M822.857143 120.32h-9.508572v22.674286c0 64.365714-47.36 116.845714-105.508571 116.845714H316.342857c-58.148571 0-105.508571-52.48-105.508571-116.845714V120.32H201.142857a103.862857 103.862857 0 0 0-103.497143 104.228571v694.857143A103.862857 103.862857 0 0 0 201.142857 1024h621.714286a103.862857 103.862857 0 0 0 103.497143-104.228571v-694.857143A103.862857 103.862857 0 0 0 822.857143 120.32z m-555.702857 283.428571H493.714286a37.668571 37.668571 0 0 1 0 75.337143H267.154286a37.668571 37.668571 0 0 1 0-75.337143z m489.691428 468.662858H267.154286a37.668571 37.668571 0 0 1 0-75.337143h489.691428a37.668571 37.668571 0 1 1 0 75.337143z m0-196.754286H267.154286a37.668571 37.668571 0 1 1 0-75.154286h489.691428a37.668571 37.668571 0 1 1 0 75.154286z"
                    p-id="12022" fill="#0269FF"></path>
              </svg>
              {{ $t('satellite.productInstruction') }}
            </p>
            <hr>
            <p class="s-name2">1{{ $t('satellite.p1') }}</p>
            <p class="s-name2">
              2{{ $t('satellite.p2') }}
            </p>
            <p class="s-name2">3{{ $t('satellite.p3') }}</p>
          </div>
        </div>
        <div class="search-box">
          <p class="title-p">
            <svg t="1638238784344" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                 p-id="12020" width="16" height="16">
              <path
                  d="M252.16 0m81.371429 0l356.937142 0q81.371429 0 81.371429 81.371429l0 55.588571q0 81.371429-81.371429 81.371429l-356.937142 0q-81.371429 0-81.371429-81.371429l0-55.588571q0-81.371429 81.371429-81.371429Z"
                  p-id="12021" fill="#0269FF"></path>
              <path
                  d="M822.857143 120.32h-9.508572v22.674286c0 64.365714-47.36 116.845714-105.508571 116.845714H316.342857c-58.148571 0-105.508571-52.48-105.508571-116.845714V120.32H201.142857a103.862857 103.862857 0 0 0-103.497143 104.228571v694.857143A103.862857 103.862857 0 0 0 201.142857 1024h621.714286a103.862857 103.862857 0 0 0 103.497143-104.228571v-694.857143A103.862857 103.862857 0 0 0 822.857143 120.32z m-555.702857 283.428571H493.714286a37.668571 37.668571 0 0 1 0 75.337143H267.154286a37.668571 37.668571 0 0 1 0-75.337143z m489.691428 468.662858H267.154286a37.668571 37.668571 0 0 1 0-75.337143h489.691428a37.668571 37.668571 0 1 1 0 75.337143z m0-196.754286H267.154286a37.668571 37.668571 0 1 1 0-75.154286h489.691428a37.668571 37.668571 0 1 1 0 75.154286z"
                  p-id="12022" fill="#0269FF"></path>
            </svg>
            {{ $t('satellite.DataRetrieval') }}
          </p>
          <hr>
          <div class="t4" v-if="productVo.cloudCover==='Y'">
            <div style="font-size: 14px;">
              {{ $t('satellite.CloudCoverSize') }}：
            </div>
            <el-slider v-model="cloudCover" :min="0" :max="100" style="width:50%;margin-left:12px;"></el-slider>
          </div>
          <div class="t1">
            <div style="font-size: 14px;">
              {{ $t('satellite.TimeRange') }}：
              <el-date-picker
                  v-model="startTimeValue"
                  @change="queryTime"
                  size="mini"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  :placeholder="$t('satellite.Start')">
              </el-date-picker>
              <span style="margin:0 12px;">-</span>
              <el-date-picker
                  v-model="endTimeValue"
                  @change="queryTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  size="mini"
                  :placeholder="$t('satellite.End')">
              </el-date-picker>
            </div>
          </div>
          <div style="text-align: right;margin-bottom: 10px">
            <span class="quick-s" @click="tiemButton(7)" :class="activeValue===7?'active':''">{{ $t('satellite.WithinOneWeek') }}</span>
            <span class="quick-s" @click="tiemButton(30)" :class="activeValue===30?'active':''">{{ $t('satellite.WithinOneMonth') }}</span>
            <span class="quick-s" @click="tiemButton(90)" :class="activeValue===90?'active':''">{{ $t('satellite.WithinOneQuarter') }}</span>
            <span class="quick-s" @click="tiemButton(180)" :class="activeValue===180?'active':''">{{ $t('satellite.WithinHalfayear') }}</span>
            <span class="quick-s" style="margin-right:0" @click="tiemButton(365)" :class="activeValue===365?'active':''">{{
                $t('satellite.Withinoneyear')
              }}</span>
          </div>
          <div>
            <div class="t2" style="font-size: 14px;">
              {{ $t('satellite.SpaceLocation') }}：
              <el-checkbox class="info-checkbox-div" v-model="checkedSpace.t1" @change="handleCheckedSpaceChange(1)">
                {{ $t('satellite.SearchbyMap') }}
              </el-checkbox>
              <el-checkbox class="info-checkbox-div" v-model="checkedSpace.t2" @change="handleCheckedSpaceChange(2)">
                {{ $t('satellite.LongitudeandLatitude') }}
              </el-checkbox>
              <el-checkbox class="info-checkbox-div" v-model="checkedSpace.t3" @change="handleCheckedSpaceChange(3)">
                {{ $t('satellite.AreaSearch') }}
              </el-checkbox>
              <el-checkbox class="info-checkbox-div" v-model="checkedSpace.t4" @change="handleCheckedSpaceChange(4)">
                {{ $t('satellite.ImportPolygon') }}
              </el-checkbox>
            </div>
            <div class="t3">
              <div class="left">
                <div v-if="checkedSpace.t1" class="draw-myself">
                  <div class="tool-site">
                    {{ $t('satellite.TaptoSelect') }}：
                    <img :class="activeDraw===1?'img-ac':''" @click="addPointe" src="../../../images/point.png" alt="">
                  </div>
                  <div class="tool-site">
                    {{ $t('satellite.Rectangle') }}：
                    <img :class="activeDraw===2?'img-ac':''" @click="addRectArea" src="../../../images/area.png" alt="">
                  </div>
                  <div class="tool-site">
                    {{ $t('satellite.Polygon') }}：
                    <img :class="activeDraw===3?'img-ac':''" @click="drawPolygons" src="../../../images/polygon.png"
                         alt="">
                  </div>
                </div>
                <div v-if="checkedSpace.t2" class="input-sizhi">
                  <div class="sizhi-lon">
                    <span class="sizhi-name">{{ $t('satellite.longitude') }}：</span>
                    <el-input size="mini" :placeholder="$t('satellite.latitude1')" v-model="lng1"
                              style="float: left; width: 240px;margin-left: 1%;margin-top: -4px;">
                      <span slot="suffix" style="transform: translateY(5px);display: inline-block;">(W)</span>
                    </el-input>
                    <el-input size="mini" :placeholder="$t('satellite.latitude2')" v-model="lng2"
                              style="float: left; width: 240px;margin-left: 1%;margin-top: -4px;">
                      <span slot="suffix" style="transform: translateY(5px);display: inline-block;">(E)</span>
                    </el-input>
                  </div>
                  <div class="sizhi-lat">
                    <span class="sizhi-name">{{ $t('satellite.latitude') }}：</span>
                    <el-input size="mini" :placeholder="$t('satellite.latitude3')" v-model="lat1"
                              style="float: left; width: 240px;margin-left: 1%;margin-top: -4px;">
                      <span slot="suffix" style="transform: translateY(5px);display: inline-block;">(S)</span>
                    </el-input>
                    <el-input size="mini" :placeholder="$t('satellite.latitude4')" v-model="lat2"
                              style="float: left; width: 240px;margin-left: 1%;margin-top: -4px;">
                      <span slot="suffix" style="transform: translateY(5px);display: inline-block;">(N)</span>
                    </el-input>
                  </div>
                </div>
                <div v-if="checkedSpace.t3" class="input-sizhi">
                  <el-radio-group v-model="radio">
                    <el-radio :label="8">{{ $t('satellite.Arctic') }}</el-radio>
                    <el-radio :label="9">{{ $t('satellite.Antarctic') }}</el-radio>
                    <el-radio :label="3">{{ $t('satellite.SouthChinaSea') }}</el-radio>
                    <el-radio :label="4">{{ $t('satellite.EastChinaSea') }}</el-radio>
                    <el-radio :label="5">{{ $t('satellite.YellowSea') }}</el-radio>
                    <el-radio :label="7">{{ $t('satellite.BohaiSea') }}</el-radio>
                    <el-radio :label="6">{{ $t('satellite.bridge') }}</el-radio>
                  </el-radio-group>
                </div>
                <div v-if="checkedSpace.t4" class="uoload-file">
                  <div class="d1">
                    <el-input size="mini" v-model="areaFile.name" disabled></el-input>
                    <el-upload
                        class="upload-demo"
                        :before-upload="onBeforeUploadImage"
                        action="string"
                        :show-file-list="false"
                        multiple>
                      <el-button size="mini">{{ $t('satellite.import') }}</el-button>
                    </el-upload>
                  </div>
                  <p class="p1">{{ $t('satellite.tips') }}</p>
                </div>
              </div>
              <div class="right">
                <el-button class="bg-btn" size="medium" type="primary" plain
                           style="float: right; width: 150px;margin-left: 1%;margin-top: -4px;" @click="resetting">
                  {{ $t('satellite.reset') }}
                </el-button>
                <el-button size="medium" :loading="sq_loading" type="primary" @transferMap="setTransferMap"
                           @click="sateTable1" style="float: right; width: 150px;margin-left: 10%;margin-top: -4px;">
                  {{ $t('satellite.Search') }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mapBox">
        <div class="change-map" @mouseover="ischange=true" @mouseout="ischange=false">
          <div class="map-box" v-show="ischange">
            <p class="p1">{{ $t('cloudComputing.Chooseabasemap') }}</p>
            <hr>
            <div class="b-box centerS">
              <div class="base-site center2" @click="changeMap(i)" :class="i.isAc?'map-ac':'map-d-ac'"
                   v-for="i in isEnglish?basemapOne_en:basemapOne" :key="i.index">
                <img :src="i.img" alt="">
                <p>{{ i.name }}</p>
              </div>
            </div>
          </div>
          <div class="parent center">
            <img src="@/assets/image/earth.png" alt="">
          </div>
        </div>
        <div class="change-view" @click="viewMap">
          <img src="@/assets/image/2D.png" alt="" v-if="show2d">
          <img src="@/assets/image/3D.png" alt="" v-else>
        </div>
        <div class="sateInfoMap" id="sateInfoMap" v-show="show2d">
          <p>{{ $t('cloudComputing.Mapsource') }}：{{ basemapOne[2].isAc ? '谷歌' : $t('cloudComputing.Tianditu') }}</p>
        </div>
        <div class="earthmap sateInfoMap" id="earthMap" v-show="!show2d">
          <p>{{ $t('cloudComputing.Mapsource') }}：{{ basemapOne[2].isAc ? '谷歌' : $t('cloudComputing.Tianditu') }}</p>
        </div>
        <SateTable v-show="accuseitem.list.length>0" ref="SateTableOn" @closeVisPanel="closeVisPanel"
                   @addAllToShopcar="addAllToShopcar" @rowSelect="rowSelect" @changePageSize="changePageSize"
                   @rowLeave="rowLeave" @rowHover="rowHover" :productInfo="productVo" :accuseVisible="accuseVisible"
                   :accuseitem="accuseitem" @setCurrentChange="getCurrentChange"></SateTable>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '../../../components/Footer.vue'
import Header from '../../../components/Header.vue'
import SateTable from './table/Satellite-info-table.vue'
import shp from "shpjs"

import L from 'leaflet';
import {tiandituTileLayer} from '@supermap/iclient-leaflet';
import 'leaflet-draw'
import {dwq, north, south, southSea, eastSea, huang, boSea} from "@/utils/local"
import {
  getSatelliteInfo,
  getSatelliteListForEs,
  getHasDataByProductId,
  allAddShopcar
} from "@/api/satellite/index"
let viewer
const Cesium = window.Cesium
var dataSourceHover,dataSourceSelect,dataSourceDraw,dataSourceArea
import Cesium_Draw from "@/utils/CesiumDraw"
import togeojson from '@mapbox/togeojson'

export default {
  components: {Header, Footer, SateTable},
  data() {
    return {
      CesiumDraw:null,
      labelImagery:null,
      labelImagerySL:null,
      labelImageryGoogle:null,
      show2d:true,
      //二三维 👆
      basemapOne: [
        {img: require('../../../assets/image/yx.png'), isAc: true, name: "天地图(影像)", index: 0},
        {img: require('../../../assets/image/sl.png'), isAc: false, name: "天地图(矢量)", index: 1},
        {img: require('../../../assets/image/yx.png'), isAc: false, name: "谷歌(影像)", index: 2},
      ],
      basemapOne_en: [
        {img: require('../../../assets/image/yx.png'), isAc: true, name: "Tian Di Tu(image)", index: 0},
        {img: require('../../../assets/image/sl.png'), isAc: false, name: "Tian Di Tu(vector)", index: 1},
        {img: require('../../../assets/image/yx.png'), isAc: false, name: "Google(image)", index: 2},
      ],
      ischange: false,
      radio: 3,
      areaFile: {
        name: ''
      },
      loadingRange: false,
      cloudCover: 20,
      activeDraw: 0,
      showInfoTable: false,
      accuseitem: {
        list: []
      },
      showDataCover: false,
      accuseVisible: false, //默认不显示弹窗
      seachCheck: false,
      options: [
        {value: 1, label: '1月'},
        {value: 2, label: '2月'},
        {value: 3, label: '3月'},
        {value: 4, label: '4月'},
        {value: 5, label: '5月'},
        {value: 6, label: '6月'},
        {value: 7, label: '7月'},
        {value: 8, label: '8月'},
        {value: 9, label: '9月'},
        {value: 10, label: '10月'},
        {value: 11, label: '11月'},
        {value: 12, label: '12月'},
      ],
      checkedSpace: {
        t1: true,
        t2: false,
        t3: false,
        t4: false,
      },
      sq_loading: false,
      mouthValue: '',
      startTimeValue: null,
      endTimeValue: null,
      productVo: {
        cloudCover: 'N',
        showDataScope: 'N'
      },
      pkid: '',
      dateSpan: '',
      dateInterval: '',
      dubboMap: [[]],
      mapView: null,
      lng1: '-180',
      lng2: '180',
      lat1: '-90',
      lat2: '90',
      lngAndLat: null,
      curPage: 1,
      pageSize: 10,
      map: null,
      stopRectArea: null,
      drawGroup: null,
      geometry: [],
      drawDataMap: [],
      AreaGroup: null,
      hoverGroup: null,
      selectGroup: null,
      isEnglish: false,
      activeValue: 0
    }
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
    this.initImageMap()
    this.initCeisum()
  },
  watch: {
    showDataCover(val) {
      if (val) {
        this.$nextTick(() => {
          this.init_alldatarange()
        })
      }
    },
    radio(val) {
      this.resetDrawRange()
      if(this.drawGroup){
        this.drawGroup.clearLayers()
      }
      let a,area
      switch (val) {
        case 6:
          area = dwq
          break;
        case 8:
          area = north
          break;
        case 9:
          area = south
          break;

        case 4:
          area = eastSea
          break;

        case 5:
          area = huang
          break;

        case 7:
          area = boSea
          break;

        default:
          area = southSea
          break;
      }
      if(this.show2d){
        a = L.geoJSON(area, {
          style: {color: 'red'}
        }).addTo(this.drawGroup);
        let parData = a.getLayers()[0]
        const fitbounds = parData._bounds
        parData = parData._latlngs[0]
        let nes = []
        parData.forEach(element => {
          nes.push([element.lat, element.lng])
        });
        this.drawDataMap = nes
        this.map.fitBounds(fitbounds)
      }else{
        if(val===8){
          //north
          dataSourceDraw.entities.add({
            id: "north",
            rectangle: {
                coordinates: Cesium.Rectangle.fromDegrees(-180, 60, 180, 90),
                material:Cesium.Color.BLUE.withAlpha(0.2),
            }
          });
        }else if(val===9){
          //south
          dataSourceDraw.entities.add({
            id: "south",
            rectangle: {
                coordinates: Cesium.Rectangle.fromDegrees(-180, -90, 180, -60),
                material:Cesium.Color.BLUE.withAlpha(0.2),
            }
          });
        }else{
          let carList = Cesium.Cartesian3.fromDegreesArray(area.features[0].geometry.coordinates[0].flat())
          dataSourceDraw.entities.add({
            polygon: {
                hierarchy: {
                    positions: carList,
                },
                material:Cesium.Color.BLUE.withAlpha(0.2),
            },
          });
        }
        let nes = this.getArrayXY(area)
        this.drawDataMap = nes
      }
    },
    checkedSpace(val) {
      this.resetDrawRange()
      if(this.drawGroup){
        this.drawGroup.clearLayers()
      }
      if (val.t3) {
        if(this.show2d){
          this.radio = 3
          let a = L.geoJSON(southSea, {
            style: {color: 'red'}
          }).addTo(this.drawGroup);
          let parData = a.getLayers()[0]
          const fitbounds = parData._bounds
          this.map.fitBounds(fitbounds)
          parData = parData._latlngs[0]
          let nes = []
          parData.forEach(element => {
            nes.push([element.lat, element.lng])
          });
          this.drawDataMap = nes
        }else{
          this.radio = 3
          let carList = Cesium.Cartesian3.fromDegreesArray(southSea.features[0].geometry.coordinates[0].flat())
          dataSourceDraw.entities.add({
            polygon: {
                hierarchy: {
                    positions: carList,
                },
                material:Cesium.Color.BLUE.withAlpha(0.2),
            },
          });
          let nes = this.getArrayXY(southSea)
          this.drawDataMap = nes
        }
      }
    }
  },
  created() {
    this.pkid = this.$route.query.sateInfo;
    const params = {
      "id": this.pkid
    }
    getSatelliteInfo(params).then(({data}) => {
      this.productVo = data;
      const language = window.localStorage.getItem('language')
      if (language === 'zh') {
        this.dateSpan = this.productVo.startTime.substr(0, 7) + "至" + this.productVo.endTime.substr(0, 7);
      }
      if (language === 'en') {
        this.dateSpan = this.productVo.startTime.substr(0, 7) + " To " + this.productVo.endTime.substr(0, 7);
      }
      this.dateInterval = this.productVo.endTime;
    })
    this.tiemButton(30)
  },

  methods: {
    /**
     * @description: 切换不同的地图模式 二三维
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-08-10 15:03:51
     * @return {*}
     */
    viewMap(){
      this.show2d = !this.show2d
      this.drawDataMap = []
      this.radio = 3
      this.checkedSpace = {
        t1: true,
        t2: false,
        t3: false,
        t4: false,
      }
      this.activeDraw = 0
      if(this.show2d){
        this.drawGroup.clearLayers()
        this.AreaGroup.clearLayers()
        this.hoverGroup.clearLayers()
        this.selectGroup.clearLayers()
      }else{
        dataSourceHover.entities.removeAll()
        dataSourceSelect.entities.removeAll()
        dataSourceDraw.entities.removeAll()
        dataSourceArea.entities.removeAll()
      }
      this.$refs.SateTableOn.closeVis()
    },
    /**
     * @description: 重置draw range
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-08-10 13:52:17
     * @return {*}
     */
    resetDrawRange(){
      if(this.show2d){
        //pass
      }else{
        dataSourceDraw.entities.removeAll()
      }
    },
    /**
     * @description: 根据geojson获取xy二维数组
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-08-09 16:38:45
     * @param {*} geojson
     * @return {*}
     */
    getArrayXY(geojson){
      let a = geojson.features[0].geometry.coordinates[0]
      let c = []
      a.forEach(element => {
        c.push([element[1],element[0]])
      });
      return c
    },
    /**
     * @description: 初始化三维cesium
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-08-09 09:05:47
     * @return {*}
     */
    initCeisum() {
      Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4NjJhZTlhZC00ZjE4LTRhYjYtYWI5Zi02MDQ3YjA1OTI5NjAiLCJpZCI6NjEwNTMsImlhdCI6MTYyNTY0ODgwMX0.BfdY8ePnShWrZomg9sv4dz8G5EG28Jva1dVFgmE7En4';
      viewer = new Cesium.Viewer('earthMap', {
        animation: false, //创建动画部件
        shouldAnimate: true,
        orderIndependentTranslucency: false,
        contextOptions: {
          webgl: {alpha: true},
          requestWebgl2: true
        },
        navigation: false,
        enableLighting: true,
      });
      viewer.scene.globe.depthTestAgainstTerrain = false;//关闭深度检测
      //init结束

      //去掉超图supermap
      viewer._cesiumWidget._creditContainer.style.display = "none";
      viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
      viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK)

      //日照
      viewer.scene.globe.enableLighting = false
      viewer.scene.sun.show = false
      viewer.scene.moon.show = false
      viewer.scene.skyBox.show = false
      viewer.scene.backgroundColor = new Cesium.Color(0.0, 0.0, 0.0, 1)

      viewer.imageryLayers.removeAll()
      this.YX = new Cesium.TiandituImageryProvider({
        mapStyle: Cesium.TiandituMapsStyle.IMG_C, //天地图全球中文注记服务（经纬度投影）
        token: '859e010cf86575ec92544de21ad4472e',
      });
      this.SL = new Cesium.TiandituImageryProvider({
        mapStyle: Cesium.TiandituMapsStyle.VEC_C, //天地图全球中文注记服务（经纬度投影）
        token: '859e010cf86575ec92544de21ad4472e',
      });
      this.GG = new Cesium.UrlTemplateImageryProvider({
        url: "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s&gl=CN&x={x}&y={y}&z={z}"
      });
      if(!this.isEnglish){
        this.BZ = new Cesium.TiandituImageryProvider({
          mapStyle : Cesium.TiandituMapsStyle.CIA_C,//天地图全球中文注记服务（经纬度投影）
          token: '859e010cf86575ec92544de21ad4472e'
        });
      }else{
        this.BZ = new Cesium.TiandituImageryProvider({
          mapStyle : Cesium.TiandituMapsStyle.EIA_C,//天地图全球中文注记服务（经纬度投影）
          token: '859e010cf86575ec92544de21ad4472e'
        });
      }
      this.labelImagery = viewer.imageryLayers.addImageryProvider(this.YX);
      viewer.imageryLayers.addImageryProvider(this.BZ);
      
      
      dataSourceHover = new Cesium.CustomDataSource("hoverArea");
      dataSourceSelect = new Cesium.CustomDataSource("selectArea");
      dataSourceDraw = new Cesium.CustomDataSource("drawArea");
      dataSourceArea = new Cesium.CustomDataSource("Area");
      viewer.dataSources.add(dataSourceHover);
      viewer.dataSources.add(dataSourceSelect);
      viewer.dataSources.add(dataSourceDraw);
      viewer.dataSources.add(dataSourceArea);

      this.CesiumDraw= new Cesium_Draw(viewer,dataSourceDraw,dataSourceArea)

    },
    /**
     * @description: 时间判断是否超过一年
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-08-05 09:33:08
     * @param {*} time
     * @return {*}
     */
    queryTime(time){
      console.log(time);
      this.startTimeValue
      this.endTimeValue
      const end = Date.parse(new Date(this.endTimeValue));
      const start = Date.parse(new Date(this.startTimeValue));
      if(end-start>1000*60*60*24*365){
        this.startTimeValue = ''
        this.endTimeValue = ''
        this.$message.warning('查询时间段不能超过一年，请重新选择时间段!')
      }
    },
    async init_alldatarange() {
      let that = this
      that.loadingRange = true
      if (this.coverMap) {
        this.coverMap.remove()
      }
      this.coverMap = L.map('alldatarange', {
        crs: L.CRS.TianDiTu_WGS84,
        center: [35, 70],
        zoom: 3,
        minZoom: 0,
        maxZoom: 10,
        maxBounds: [
          [-89.9999999999999, -179.9999999999999],
          [89.9999999999999, 179.9999999999999]
        ],
        zoomControl: false
      });
      this.coverGroup = L.layerGroup().addTo(this.coverMap);
      tiandituTileLayer({
        layerType: 'img',
        key: '73ae12883e85f0abe62f8941835a4129',
        noWrap: false,
      })
          .addTo(this.coverMap);
      if (!this.isEnglish) {
        tiandituTileLayer({
          layerType: 'img',
          isLabel: true,
          key: '73ae12883e85f0abe62f8941835a4129',
          noWrap: false,
        })
            .addTo(this.coverMap);
      } else {
        tiandituTileLayer({
          url: 'http://t0.tianditu.gov.cn/eia_c/wmts?&layer=eia&',
          layerType: 'img',
          isLabel: true,
          key: '73ae12883e85f0abe62f8941835a4129'
        })
            .addTo(this.coverMap);
      }

      let res = await getHasDataByProductId({
        productId: that.pkid
      })
      let dealDataWG = res.data.baseData.map(item => item.orbitalFeatures)
      let dealDataSJ = res.data.dataList.map(item => item.orbitalFeatures)
      let geoResult = {
        type: "FeatureCollection",
        features: dealDataWG
      }
      let geoResult_sj = {
        type: "FeatureCollection",
        features: dealDataSJ
      }
      L.geoJSON(geoResult, {
        style: {color: 'rgba(132,140,153,0.7)', fillColor: 'rgba(126,126,126,0.5)'}
      }).addTo(this.coverMap);

      L.geoJSON(geoResult_sj, {
        style: {color: '#409eff'}
      }).addTo(this.coverMap);

      that.loadingRange = false
    },
    closeVisPanel() {
      if(this.show2d){
        this.selectGroup.clearLayers()
        this.AreaGroup.clearLayers()
      }else{
        dataSourceSelect.entities.removeAll()
        dataSourceHover.entities.removeAll()
        dataSourceArea.entities.removeAll()
      }
    },
    /**
     * @description: 二维selected add image
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-08-09 15:54:20
     * @param {*} val
     * @return {*}
     */
    rowSelectImage(val) {
      if (val.location_shape.type === "polygon") {
        let a = []
        val.location_shape.coordinates[0].forEach(element => {
          a.push([parseFloat(element[1]), parseFloat(element[0])])
        });

        this.imageLayer = L.imageOverlay(val.mediaUrl, a, {
          zIndex: 99999
        })
        this.selectGroup.addLayer(this.imageLayer)
      }
    },
    /**
     * @description: 3维selected add image
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-08-09 15:54:43
     * @param {*} val
     * @return {*}
     */
    rowSelectImage3d(val){
      dataSourceSelect.entities.add({
        rectangle: {
            coordinates: Cesium.Rectangle.fromDegrees(
              val.sdriW, val.sdriS, val.sdriE, val.sdriN
            ),
            material:new Cesium.ImageMaterialProperty({
              image:val.mediaUrl
            }),
            
        }
      });
    },
    rowSelect(val) {
      if(this.selectGroup){
        this.selectGroup.clearLayers()
      }
      if(dataSourceSelect.entities){
        dataSourceSelect.entities.removeAll()
      }
      val.forEach(element => {
        if(this.show2d){
          this.rowSelectImage(element)
        }else{
          this.rowSelectImage3d(element)
        }
      });
    },
    changeMap(val) {
      this.basemapOne.forEach(element => {
        element.isAc = false
      });
      this.basemapOne_en.forEach(element => {
        element.isAc = false
      });
      val.isAc = true
      if(this.show2d){ //二维
        switch (val.index) {
          case 0:
            this.initImageMap()
            break;
          case 1:
            this.initVetorMap()
            break;
          default:
            this.initImageMapGoogle()
            break;
        }
      }else{ //三维
        if(this.BZ){
          viewer.imageryLayers.remove(this.BZ);
        }
        switch (val.index) {
          case 0:
            viewer.imageryLayers.remove(this.labelImagerySL);
            viewer.imageryLayers.remove(this.labelImageryGoogle);
            this.labelImagery = viewer.imageryLayers.addImageryProvider(this.YX);
            break;
          case 1:
            viewer.imageryLayers.remove(this.labelImagery);
            viewer.imageryLayers.remove(this.labelImageryGoogle);
            this.labelImagerySL = viewer.imageryLayers.addImageryProvider(this.SL);
            break;
          default:
            viewer.imageryLayers.remove(this.labelImagerySL);
            viewer.imageryLayers.remove(this.labelImagery);
            this.labelImageryGoogle = viewer.imageryLayers.addImageryProvider(this.GG);
            break;
        }
        if(!this.isEnglish){
          this.BZ = new Cesium.TiandituImageryProvider({
            mapStyle : Cesium.TiandituMapsStyle.CIA_C,//天地图全球中文注记服务（经纬度投影）
            token: '859e010cf86575ec92544de21ad4472e'
          });
        }else{
          this.BZ = new Cesium.TiandituImageryProvider({
            mapStyle : Cesium.TiandituMapsStyle.EIA_C,//天地图全球中文注记服务（经纬度投影）
            token: '859e010cf86575ec92544de21ad4472e'
          });
        }
        viewer.imageryLayers.addImageryProvider(this.BZ)
      }
      if (this.$refs.SateTableOn.vis) {
        this.sateTable1()
      }
    },
    initImageMapGoogle() {
      if (this.map) {
        this.map.remove()
      }
      this.map = L.map('sateInfoMap', {
        CRS: L.CRS.EPSG4326,
        center: [35, 70],
        zoom: 3,
        minZoom: 2,
        maxZoom: 10,
        maxBounds: [
          //south west
          [-89.9999999999999, -179.9999999999999],
          //north east
          [89.9999999999999, 179.9999999999999]
        ],
        zoomControl: false
      });
      this.drawGroup = L.layerGroup().addTo(this.map);
      this.AreaGroup = L.layerGroup().addTo(this.map);
      this.hoverGroup = L.layerGroup().addTo(this.map);
      this.selectGroup = L.layerGroup().addTo(this.map);
      if (!this.isEnglish) {
        L.tileLayer('https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s,m&gl=CN&hl=zh-CN&x={x}&y={y}&z={z}', {
          maxZoom: 20,
        }).addTo(this.map);
      }else{
        L.tileLayer('https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s,m&gl=EN&hl=en-US&x={x}&y={y}&z={z}', {
          maxZoom: 20,
        }).addTo(this.map);
      }
    },
    initImageMap() {
      if (this.map) {
        this.map.remove()
      }
      this.map = L.map('sateInfoMap', {
        crs: L.CRS.TianDiTu_WGS84,
        center: [35, 70],
        zoom: 3,
        minZoom: 2,
        maxZoom: 10,
        maxBounds: [
          //south west
          [-89.9999999999999, -179.9999999999999],
          //north east
          [89.9999999999999, 179.9999999999999]
        ],
        zoomControl: false
      });
      this.drawGroup = L.layerGroup().addTo(this.map);
      this.AreaGroup = L.layerGroup().addTo(this.map);
      this.hoverGroup = L.layerGroup().addTo(this.map);
      this.selectGroup = L.layerGroup().addTo(this.map);
      tiandituTileLayer({
        layerType: 'img',
        key: '73ae12883e85f0abe62f8941835a4129',
        noWrap: false,
      })
          .addTo(this.map);
      if (!this.isEnglish) {
        tiandituTileLayer({
          layerType: 'img',
          isLabel: true,
          key: '73ae12883e85f0abe62f8941835a4129',
          noWrap: false,
        })
            .addTo(this.map);
      } else {
        tiandituTileLayer({
          url: 'http://t0.tianditu.gov.cn/eia_c/wmts?&layer=eia&',
          layerType: 'img',
          isLabel: true,
          key: '73ae12883e85f0abe62f8941835a4129'
        })
            .addTo(this.map);
      }
    },
    initVetorMap() {
      if (this.map) {
        this.map.remove()
      }
      this.map = L.map('sateInfoMap', {
        crs: L.CRS.TianDiTu_WGS84,
        center: [35, 70],
        zoom: 3,
        minZoom: 2,
        maxZoom: 10,
        maxBounds: [
          //south west
          [-89.9999999999999, -179.9999999999999],
          //north east
          [89.9999999999999, 179.9999999999999]
        ],
        zoomControl: false
      });
      this.drawGroup = L.layerGroup().addTo(this.map);
      this.AreaGroup = L.layerGroup().addTo(this.map);
      this.hoverGroup = L.layerGroup().addTo(this.map);
      this.selectGroup = L.layerGroup().addTo(this.map);
      L.supermap
          .tiandituTileLayer({
            key: 'bb11a33c4377f10603478ed166691455',
            noWrap: false,
          })
          .addTo(this.map);
      if (!this.isEnglish) {
        tiandituTileLayer({
          layerType: 'img',
          isLabel: true,
          key: '73ae12883e85f0abe62f8941835a4129',
          noWrap: false,
        })
            .addTo(this.map);
      } else {
        tiandituTileLayer({
          url: 'http://t0.tianditu.gov.cn/eia_c/wmts?&layer=eia&',
          layerType: 'img',
          isLabel: true,
          key: '73ae12883e85f0abe62f8941835a4129'
        })
            .addTo(this.map);
      }
    },
    changePageSize(val) {
      this.pageSize = val
      this.sateTable1()
    },
    fileToBuf(file) {
      let that = this
      var fr = new FileReader();
      fr.readAsArrayBuffer(file);
      fr.addEventListener("loadend", (e) => {
        var buf = e.target.result;
        shp(buf).then(function (data) {
          that.$message.success('解析成功')
          data.features.forEach(element => {
            var latlngs = element.geometry.coordinates
            let a = []
            latlngs[0].forEach(element => {
              a.push([element[1], element[0]])
            });
            that.drawDataMap = a
            L.polygon(a, {color: 'red', fillColor: 'rgba(255,0,0,0)'}).addTo(that.drawGroup);
          });
        }).catch(function () {
          that.$message.error('该shp文件解析错误，请检查后重新上传！')
        });
      }, false);
    },
    /**
     * @description: 三维解析shp
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-08-10 10:43:23
     * @param {*} file
     * @return {*}
     */
    fileToBuf3d(file){
      let that = this
      var fr = new FileReader();
      fr.readAsArrayBuffer(file);
      fr.addEventListener("loadend", (e) => {
        var buf = e.target.result;
        shp(buf).then(function (data) {
          that.$message.success('解析成功')
          data.features.forEach(element => {
            var latlngs = element.geometry.coordinates
            let a = []
            latlngs[0].forEach(element => {
              a.push([element[1], element[0]])
            });
            that.drawDataMap = a
            const positions = element.geometry.coordinates[0].flat()
            let carList = Cesium.Cartesian3.fromDegreesArray(positions)
            dataSourceDraw.entities.add({
                polygon: {
                // 这个方法上面有重点说明
                hierarchy: {
                  positions:carList
                },
                material: Cesium.Color.RED.withAlpha(0.5),
                },
            })
          });
        }).catch(function () {
          that.$message.error('该shp文件解析错误，请检查后重新上传！')
        });
      }, false);
    },
    parseKml(file) {
      this.$message('开始解析kml文件')
      console.log(file);
      let result = window.URL.createObjectURL(file)
      var customLayer = L.geoJson(null, {
        style: function () {
          return {color: 'red'};
        }
      });
      let resultLayer = omnivore.kml(result, null, customLayer)
      let m = resultLayer.addTo(this.drawGroup)
      setTimeout(() => {
        const allLayer = m.getLayers()
        let boundsList = []
        allLayer[0]._latlngs[0].forEach(element => {
          boundsList.push([element.lat, element.lng])
        });
        this.drawDataMap = boundsList
        console.log(boundsList);
      }, 200)
    },
    /**
     * @description: 三维解析kml并加载
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-08-10 09:10:07
     * @param {*} file
     * @return {*}
     */
    parseKml3d(file){
      let reader = new FileReader();
      reader.readAsText(file,'utf-8');
      reader.onload = (e)=>
      {
          const xml = new DOMParser().parseFromString(e.target.result, 'text/xml')
          const jsons = togeojson.kml(xml, {
            style: true
          })
          let latlng = []
          jsons.features[0].geometry.coordinates[0].forEach(element => {
            latlng.push([element[1], element[0]])
          });
          this.drawDataMap = latlng
      }
      
      let reader2 = new FileReader();
      reader2.readAsDataURL(file);
      reader2.onload = ()=>
      {
          let options = {
              camera : viewer.scene.camera,
              canvas : viewer.scene.canvas
          }
          Cesium.KmlDataSource.load(reader2.result,options).then((KmlDataSource)=>{
            viewer.dataSources.add(KmlDataSource)
          });
      }
    },
    onBeforeUploadImage(file) {
      this.areaFile = file
      if (file.name.endsWith('kml')) {
        if(this.show2d){
          this.parseKml(file)
        }else{
          this.parseKml3d(file)
        }
        return
      }
      this.$message('开始解析shp文件')
      if(this.show2d){
        this.fileToBuf(file)
      }else{
        this.fileToBuf3d(file)
      }
    },
    rowLeave() {
      this.hoverGroup&&this.hoverGroup.clearLayers()
      dataSourceHover.entities&&dataSourceHover.entities.removeAll()
    },
    rowHover(val) {
      if(this.show2d){
        var polygon
        if (val.location_shape.type === "multipolygon") {
          let b = []
          val.location_shape.coordinates[0][0].forEach(element => {
            b.push([parseFloat(element[1]), parseFloat(element[0])])
          });
          polygon = L.polygon(b, {color: 'green'});
          this.hoverGroup.addLayer(polygon)

          b = []
          val.location_shape.coordinates[1][0].forEach(element => {
            b.push([parseFloat(element[1]), parseFloat(element[0])])
          });
          polygon = L.polygon(b, {color: 'green'});
          this.hoverGroup.addLayer(polygon)
        } else {
          let a = []
          val.location_shape.coordinates[0].forEach(element => {
            a.push([parseFloat(element[1]), parseFloat(element[0])])
          });

          polygon = L.polygon(a, {color: 'green', fillOpacity: '0'});
          this.hoverGroup.addLayer(polygon)
          if (val.mediaUrl) {
            this.imageLayer = L.imageOverlay(val.mediaUrl, a, {
              zIndex: 999999
            })
            this.hoverGroup.addLayer(this.imageLayer)
          }
        }
      }else{
        //3维
        dataSourceHover.entities.add({
          id: "hoverimage",
          rectangle: {
              coordinates: Cesium.Rectangle.fromDegrees(
                val.sdriW, val.sdriS, val.sdriE, val.sdriN
              ),
              material:new Cesium.ImageMaterialProperty({
                image:val.mediaUrl
              }),
              
          }
        });
      }
    },
    addPointe() {
      let that = this
      let node
      this.activeDraw = 1
      this.drawDataMap = []
      this.$message(this.isEnglish ? 'Start drawing the point range' : '开始绘制点范围');
      function onClick(e) {
        node = L.circleMarker(e.latlng, {
          radius: 3,
          color: 'rgba(51,136,255,1)',
          fillColor: 'rgba(51,136,255,1)',
          fillOpacity: 1
        })
        that.drawGroup.addLayer(node)
        that.drawDataMap.push([e.latlng.lat, e.latlng.lng])
        that.map.off('click', onClick);    //点击地图
        that.activeDraw = 0
      }
      if(this.show2d){
        this.drawGroup.clearLayers()
        this.removePolygon()
        that.map.on('click', onClick);    //点击地图
      }else{
        that.resetDrawRange()
        that.CesiumDraw.addPoint().then(res =>{
          console.log(res);
          that.drawDataMap.push(res)
          that.activeDraw = 0
        })
      }
    },
    addRectArea() {
      this.$message(this.isEnglish ? 'Start box range' : '开始框选范围');
      this.activeDraw = 2
      this.drawDataMap = []
      var that = this;
      if(this.show2d){
        this.removePolygon()

        that.map.off("click")
        that.map.off("dblclick")
        that.map.off("dblclick")
        this.drawGroup.clearLayers()
        if (that.stopRectArea != null) {  //stopRectArea在data中定义，清除重复的拉框操作
          that.map.off('mousedown', that.stopRectArea.mousedown);
        }
        var rectangleMeasure = {
          startPoint: null,
          endPoint: null,
          rectangle: null,
          layer: this.drawGroup,
          color: "rgba(51,136,255,1)",
          addRectangle: function () {
            rectangleMeasure.destory();
            var bounds = [];
            bounds.push(rectangleMeasure.startPoint);
            bounds.push(rectangleMeasure.endPoint);
            rectangleMeasure.rectangle = L.rectangle(bounds, {color: rectangleMeasure.color, weight: 1});
            rectangleMeasure.rectangle.addTo(rectangleMeasure.layer);
            rectangleMeasure.layer.addTo(that.map);
          },
          mousedown: function (e) {
            rectangleMeasure.rectangle = null;
            that.map.dragging.disable();
            rectangleMeasure.startPoint = e.latlng;
            that.map.on('mousemove', rectangleMeasure.mousemove)
          },
          mousemove: function (e) {
            rectangleMeasure.endPoint = e.latlng;
            rectangleMeasure.addRectangle();
            that.map.off('mousedown ', rectangleMeasure.mousedown).on('mouseup', rectangleMeasure.mouseup);
          },
          mouseup: function () {
            that.map.dragging.enable();
            that.map.off('mousemove', rectangleMeasure.mousemove).off('mouseup', rectangleMeasure.mouseup);
            that.locations = {}; //locations在data中定义
            that.locations['leftX'] = rectangleMeasure.startPoint.lat;
            that.locations['leftY'] = rectangleMeasure.startPoint.lng;
            that.locations['rightX'] = rectangleMeasure.endPoint.lat;
            that.locations['rightY'] = rectangleMeasure.endPoint.lng;
            that.locations['layer_id'] = rectangleMeasure.layer._leaflet_id;
            that.locations['layer'] = rectangleMeasure.layer;
            that.locations['rectangle'] = rectangleMeasure.rectangle;
            that.drawDataMap.push([rectangleMeasure.startPoint.lat, rectangleMeasure.startPoint.lng])
            that.drawDataMap.push([rectangleMeasure.endPoint.lat, rectangleMeasure.startPoint.lng])
            that.drawDataMap.push([rectangleMeasure.endPoint.lat, rectangleMeasure.endPoint.lng])
            that.drawDataMap.push([rectangleMeasure.startPoint.lat, rectangleMeasure.endPoint.lng])
            // that.drawDataMap.push(())
            //在此处对数据进行处理（1）...
            that.activeDraw = 0
          },
          destory: function () {
            if (rectangleMeasure.rectangle)
              rectangleMeasure.layer.removeLayer(rectangleMeasure.rectangle);
          }
        };
        that.stopRectArea = rectangleMeasure; //记录已点击拉框按钮，未在地图上拉框
        that.map.on('mousedown', rectangleMeasure.mousedown); //在地图上拉框
      }else{
        that.resetDrawRange()
        that.CesiumDraw.addRect().then(res =>{
          console.log(res);
          that.drawDataMap = res
          that.activeDraw = 0
        })
      }
    },
    removePolygon() {
      for (let ooo of this.geometry) {
        ooo.remove();
      }
    },
    drawPolygons() {
      let that = this
      this.drawDataMap = []
      this.$message(this.isEnglish ? 'Start drawing the polygon range' : '开始绘制多边形范围');
      this.activeDraw = 3
      
      function drawPolygon() {
        that.map.doubleClickZoom.disable();
        lines = new L.polyline([]);
        tempLines = new L.polyline([], {dashArray: 5});
        points = [];
        that.geometry = [];
        that.map.on('click', onClick);    //点击地图
        that.map.on('dblclick', onDoubleClick);
        that.map.on('mousemove', onMove)//双击地图

        function onClick(e) {
          points.push([e.latlng.lat, e.latlng.lng])
          lines.addLatLng(e.latlng)
          // that.map.addLayer(tempLines)
          // that.map.addLayer(lines)
          that.drawGroup.addLayer(tempLines)
          that.drawGroup.addLayer(lines)
          node = L.circle(e.latlng, {color: '#ff0000', fillColor: '#ff0000', fillOpacity: 1})
          // that.map.addLayer(node)
          that.drawGroup.addLayer(node)
          that.geometry.push(node)
        }

        function onMove(e) {
          if (points.length > 0) {
            let ls = [points[points.length - 1], [e.latlng.lat, e.latlng.lng], points[0]]
            tempLines.setLatLngs(ls)
            // that.map.addLayer(tempLines)
          }
        }

        function onDoubleClick() {
          that.geometry.push(L.polygon(points).addTo(that.map))
          that.drawDataMap = points
          that.drawDataMap.splice(that.drawDataMap.length - 1, 1)
          points = [];
          node = null;
          that.map.off('click', onClick);    //点击地图
          that.map.off('dblclick', onDoubleClick);
          that.map.off('mousemove', onMove)//双击地图
          that.map.doubleClickZoom.enable();
          that.activeDraw = 0
          //isInPolygon(marker);
        }
      }

      if(this.show2d){
        this.drawGroup.clearLayers()
        var points, lines, tempLines, node;
        that.map.off("mousemove")
        that.map.off("mousedown")
        that.map.off("mouseup")


        this.removePolygon()
        drawPolygon()
      }else{
        that.resetDrawRange()
        that.CesiumDraw.addPolygon().then(res =>{
          console.log(res);
          that.drawDataMap = res
          that.activeDraw = 0
        })
      }
    },
    getCurrentChange(val) {
      this.curPage = val;
      this.sateTable1();
    },

    setTransferMap(val) {
      this.transferMap = val
    },
    tiemButton(val) {
      this.activeValue = val
      this.mouthValue = null;
      let end = new Date();
      let start = new Date();
      switch (val) {
        case 7:
          start.setDate(end.getDate() - 6);
          break;
        case 30:
          start.setDate(end.getDate() - 30);
          break;
        case 90:
          start.setDate(end.getDate() - 90);
          break;
        case 180:
          start.setDate(end.getDate() - 180);
          break;
        case 365:
          start.setDate(end.getDate() - 365);
          break;
        default:
          0
      }

      this.startTimeValue = this.dateToString(start);
      this.endTimeValue = this.dateToString(end);
    },

    dateToString(date) {
      date.setDate(date.getDate());
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hh = date.getHours();
      let mm = date.getMinutes();
      let ss = date.getSeconds();
      return date.getFullYear() + '-' + this.getFormatDate(month) + '-' + this.getFormatDate(day) + " " + this.getFormatDate(hh) + ':' + this.getFormatDate(mm) + ':' + this.getFormatDate(ss);
    },
    getFormatDate(arg) {
      if (arg === undefined || arg === '') {
        return '';
      }
      let re = arg + '';
      if (re.length < 2) {
        re = '0' + re;
      }
      return re;
    },
    //重置按钮
    resetting() {
      this.startTimeValue = ''
      this.endTimeValue = ''
      this.sq_loading = false
      this.removePolygon()
      this.drawGroup.clearLayers()
      this.selectGroup.clearLayers()
      this.AreaGroup.clearLayers()
      this.$refs.SateTableOn.CloseVis()
    },
    addAllToShopcar() {
      let that = this
      this.$confirm(this.isEnglish ? 'Are you sure to add all the query results to the shopping cart' : '确定要将所有查询结果添加到购物车中吗？', this.isEnglish ? 'Tips' : '提示', {
        confirmButtonText: this.isEnglish ? 'confirm' : '确定',
        cancelButtonText: this.isEnglish ? 'cancel' : '取消',
        customClass: 'delete-sure',
        type: 'warning'
      })
          .then(async () => {
            if (!this.startTimeValue || !this.endTimeValue) {
              return this.$message.error(this.isEnglish ? 'Please select a time range' : '请选择时间范围');
            }
            if (this.checkedSpace.t2) {
              this.drawDataMap = [
                [this.lat1, this.lng1],
                [this.lat1, this.lng2],
                [this.lat2, this.lng2],
                [this.lat2, this.lng1]
              ]
            }
            if (this.drawDataMap.length === 0) {
              return this.$message.error(this.isEnglish ? 'Please select a space range' : '请选择空间范围');
            }
            let parmas =
                {
                  endTime: this.endTimeValue,
                  pointList: this.drawDataMap,
                  satelliteName: this.productVo.satelliteName,
                  productName: this.productVo.productName,
                  startTime: this.startTimeValue,
                  cloudCover: this.cloudCover
                }

            if (this.productVo.cloudCover != 'Y') {
              delete parmas.cloudCover
            }
            parmas.endTime = parmas.endTime.substr(0, 10) + ' 23:59:59'
            parmas.startTime = parmas.startTime.substr(0, 10) + ' 00:00:00'


            let param = {
              "productId": this.productVo.pkid,
              "productLevel": this.productVo.productLevel,
              "satelliteId": this.productVo.satelliteId,
              "sensorId": this.productVo.sensorId
            }
            const resultParamas = {...parmas, ...param}
            allAddShopcar(resultParamas).then(res => {
              if (res.code == '000000') {
                this.$message.success(this.isEnglish ? 'Add successfully. Please check later' : '添加成功，请稍后查看！')
              } else {

                this.$message.error(this.isEnglish ? 'fail to add' : '添加失败！')
              }
              setTimeout(() => {
                that.$store.dispatch('getShopTotal')
              }, 2000)
            })
          }).catch(() => {
        this.$message({
          type: 'info',
          message: this.isEnglish ? 'Unadded to cart' : '已取消加入购物车'
        })
      })
    },
    //查询按钮
    sateTable1() {//  this 21
      if (this.lng2<=this.lng1) {
        return this.$message.warning(this.isEnglish ? 'Longitude (E) needs to be greater than longitude (W)' : '经度（E）需要大于经度（W）');
      }
      if (this.lat2<=this.lat1) {
        return this.$message.warning(this.isEnglish ? 'Latitude (n) needs to be greater than latitude (s)' : '纬度（N）需要大于纬度（S）');
      }
      let that = this
      that.sq_loading = true
      if (!this.startTimeValue || !this.endTimeValue) {

        that.sq_loading = false
        return this.$message.error(this.isEnglish ? 'Please select a time range' : '请选择时间范围');
      }
      if (this.checkedSpace.t2) {
        this.drawDataMap = [
          [this.lat1, this.lng1],
          [this.lat1, this.lng2],
          [this.lat2, this.lng2],
          [this.lat2, this.lng1],
          [this.lat1, this.lng1]
        ]
      }
      if (this.drawDataMap.length === 0) {
        that.sq_loading = false
        return this.$message.error(this.isEnglish ? 'Please select a space range' : '请选择空间范围');
      }
      let parmas =
          {
            page: this.curPage, //分页页码，数字类型
            endTime: this.endTimeValue,
            limit: this.pageSize,
            pointList: this.drawDataMap,
            satelliteName: this.productVo.satelliteName,
            productName: this.productVo.productName,
            startTime: this.startTimeValue,
            cloudCover: this.cloudCover
          }
      if (this.productVo.cloudCover != 'Y') {
        delete parmas.cloudCover
      }
      parmas.endTime = parmas.endTime.substr(0, 10) + ' 23:59:59'
      parmas.startTime = parmas.startTime.substr(0, 10) + ' 00:00:00'
      this.AreaGroup&&this.AreaGroup.clearLayers()
      // this 22
      console.log(parmas)
      getSatelliteListForEs(parmas).then(({data}) => {
        this.accuseitem = data;
        if (data.list.length === 0) {
          that.$message.warning(this.isEnglish ? 'No data was queried' : '未查询到数据...')
        }
        let ParseData = JSON.parse(JSON.stringify(data))
        if(that.show2d){ //二维地图添加边框
          that.AreaGroup.clearLayers()
          ParseData.list.forEach(element => {
            if (element.location_shape.type === "multipolygon") {
              that.addAllArea(element.location_shape.coordinates[1][0])
              that.addAllArea(element.location_shape.coordinates[0][0])
            } else {
              that.addAllArea(element.location_shape.coordinates[0])
            }

          });
        }else{
          //3维地图添加边框
          ParseData.list.forEach(item => {
            if (item.location_shape.type === "multipolygon") {
              item.location_shape.coordinates.forEach(elementShap => {
                let ccr = []
                elementShap[0].forEach(element => {
                    ccr.push([parseFloat(element[0]),parseFloat(element[1])])
                });
                const flatA = ccr.flat()
                let carList = Cesium.Cartesian3.fromDegreesArray(flatA)
                that.CesiumDraw.BlueCover(carList)
              });
            }else{
              item.location_shape.coordinates[0].forEach(element => {
                  element[0] = parseFloat(element[0])
                  element[1] = parseFloat(element[1])
              });
              const flatA = item.location_shape.coordinates[0].flat()
              let carList = Cesium.Cartesian3.fromDegreesArray(flatA)
              that.CesiumDraw.BlueCover(carList)
            }
          });
        }
        // this.accuseVisible = true;
        that.$refs.SateTableOn.openVis()
        this.dateSpan = this.productVo.startTime.substr(0, 7) + "至" + this.productVo.endTime.substr(0, 7);
        this.dateInterval = this.productVo.endTime;

        that.sq_loading = false
      }).catch(() =>{
        console.log('服务器繁忙');
        this.$message.warning('服务器繁忙')
        that.sq_loading = false
      })
    },
    addAllArea(arrs) {
      let a = []
      arrs.forEach(element => {
        a.push([parseFloat(element[1]), parseFloat(element[0])])
      });
      var polygon = L.polygon(a, {color: 'red'});
      this.AreaGroup.addLayer(polygon)
    },
    handleCheckedMapChange(val) {
      if (val === true) {
        this.checkedSpace = false;
        //显示地图
      }
    },
    handleCheckedSpaceChange(val) {
      this.checkedSpace = {
        t1: false,
        t2: false,
        t3: false,
        t4: false,
      }
      switch (val) {
        case 1:
          this.checkedSpace.t1 = true
          break;
        case 2:
          this.checkedSpace.t2 = true
          break;
        case 3:
          this.checkedSpace.t3 = true
          break;

        default:
          this.checkedSpace.t4 = true
          break;
      }
      this.drawDataMap = []
    }

  }


}
</script>

<style lang="scss" scoped>
.change-view{
  width: 40px;
  height: 40px;
  border-radius: 3px;
  background-color: white;
  cursor: pointer;
  position: absolute;
  right: calc(50% - 610px);
  top: 12px;
  z-index: 1000;
}
.change-map {
  position: absolute;
  right: calc(50% - 610px);
  bottom: 24px;
  z-index: 1000;
  display: flex;
  align-items: flex-end;

  .parent {
    width: 46px;
    height: 46px;
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
    margin-left: 12px;
  }

  .map-box {
    width: auto;
    height: 130px;
    background: #FFFFFF;
    border-radius: 10px;

    .p1 {
      color: black;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
    }

    hr {
      margin: 4px 0;
      width: 276px;
    }
  }

  .b-box {
    font-size: 12px;
    padding: 0 8px;

    .base-site {
      cursor: pointer;
    }

    img {
      width: 80px;
      height: 60px;
      border-radius: 4px;
    }

    .map-ac {
      img {
        border: 4px solid #3390F8;
      }

      color: #3390F8;
    }

    .map-d-ac {
      img {
        border: 4px solid white;
      }

      color: black;
    }
  }
}

/deep/ .thisblack-bgc {
  background-color: rgba(0, 0, 0, 0.5);
}

.alldatarange {
  width: 100%;
  height: 500px;
}

/deep/ .leaflet-right {
  display: none;
}

/deep/ .el-dialog.sateTable {
  float: left;
  margin-left: 3%;
}

.main {
  width: 100%;
  color: white;
  // @include sitellite_bg_v3_color();
  @include product_bg_v1_color();

  hr {
    width: calc(100% + 48px);
    margin-left: -24px;
    margin-top: 14px;
    background: linear-gradient(
            to right,
            transparent 0%,
            transparent 50%,
            rgba(102, 102, 102, 0.4) 50%,
            rgba(102, 102, 102, 0.4) 100%
    );
    background-size: 18px 1px;
    background-repeat: repeat-x;
  }

  .top-loc {
    width: 100%;
    height: 48px;
    @include sitellite_bg_v1_color();
  }

  .current-loc {
    height: 48px;
    width: 1552px;
    display: flex;
    align-items: center;

    /deep/ span {
      font-size: 15px;
      @include sitellite_detail_white();
    }

    /deep/ a {
      font-size: 15px;
      @include sitellite_detail_white();
    }

    /deep/ .el-breadcrumb__item:last-child {
      span {
        color: rgba(38, 125, 255, 1);
      }
    }
  }

  .title-p {
    font-size: 21px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #0269FF;
    line-height: 29px;
  }

  .black-bg {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 8px;

    .info {
      width: 1246px;

      .name {
        margin-top: 37px;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        @include co_white_to_black();
        line-height: 33px;
        text-align: center;
      }

      .label {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        @include sitellite_label();
        line-height: 20px;
        text-align: center;
        margin: 13px 0 29px 0;
      }

      .basic-info {
        width: 1202px;
        padding: 25px 22px;
        // background-color: rgba(18, 22, 46, 1);
        @include sitellite_bg_v1_color();

        &-site {
          margin: 8px 0;
          display: flex;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          @include sitellite_basic_info_value();

          .s-name {
            font-size: 15px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 500;
            @include sitellite_basic_info_name();
            line-height: 25px;
            margin-right: 12px;
          }

          .s1 {
            width: 36%;
          }

          .s2 {
            width: 40%;
          }

          .s3 {
            width: 24%;
          }
        }

        .s-name2 {
          font-size: 15px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 500;
          @include sitellite_basic_info_name();
          line-height: 38px;
          margin-right: 12px;
        }
      }
    }

    .search-box {
      margin-bottom: 33px;
      width: 1202px;
      margin-top: 0px;
      padding: 25px 22px;
      @include sitellite_bg_v1_color();
      @include sitellite_basic_info_name();

      .quick-s {
        cursor: pointer;
        color: #409EFF;
        border: 1px solid #409EFF;
        padding: 3px 8px;
        font-size: 14px;
        border-radius: 3px;
        margin: 0 8px;
        transition: all 0.3s;
        &.active{
          background-color: #409EFF;
          color: #fafafa;
        }
      }

      .t4 {
        width: 100%;
        display: flex;
        align-items: center;
      }

      .t1 {
        height: 48px;
        align-items: center;
        display: flex;
        justify-content: space-between;
        font-size: 15px;
      }

      .t2 {
        height: 48px;
      }

      .t3 {
        display: flex;
        padding: 0 0px 0 80px;
        justify-content: space-between;

        .left {
          .draw-myself {
            display: flex;
            align-items: center;

            .tool-site {
              margin-right: 36px;
              display: flex;
              align-items: center;
              font-size: 14px;

              img {
                width: 36px;
                height: 36px;
                cursor: pointer;
              }

              .img-ac {
                width: 30px;
                height: 30px;
                cursor: pointer;
                border: 3px solid #0269FF;
              }
            }
          }

          .uoload-file {
            .d1 {
              display: flex;

              .upload-demo {
                margin-left: 24px;
              }
            }

            .p1 {
              margin-top: 6px;
              font-size: 13px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #F10000;
            }
          }

          .input-sizhi {
            .sizhi-name {
              width: auto;
              min-width: 50px;
            }

            .sizhi-lon {
              display: flex;
              height: 36px;
            }

            .sizhi-lat {
              display: flex;
              height: 36px;
            }
          }
        }

        .right {
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .mapBox {
    height: 600px;
    width: 100%;
    position: relative;
    margin-bottom: 24px;

    .sateInfoMap {
      width: 1246px;
      margin: 0 auto;
      height: 100%;
      @include sitellite_bg_v7_color();
      position: relative;

      > p {
        position: absolute;
        bottom: 0;
        color: #ffffff;
        z-index: 1000;
        right: 10px;
        font-size: 12px;
      }
    }

    .loc-tool {
      position: absolute;
      right: 50%;
      top: 100%;
      transform: translate(calc(50% + 623px), -10px);
      z-index: 1000;
    }

    .change-base-map {
      position: absolute;
      right: 12px;
      bottom: 12px;
      overflow: hidden;
      transition: all 0.3s linear;
      border: 5px solid rgba(2, 105, 255, 0.6);
      border-radius: 5px;

      img {
        width: 40px;
        height: 40px;
      }

      .base-map-one {
        width: 40px;
        height: 40px;
      }
    }

    .change-base-map:hover {
      border: 5px solid rgba(2, 105, 255, 1);
    }
  }
}

.bg-btn {
  @include sitellite_bg_v6_color();
  color: rgba(2, 105, 255, 1);
}

.el-button--primary.is-plain:hover {
  color: rgba(2, 105, 255, 0.4);
}

.el-button--primary.is-plain:focus {
  color: rgba(2, 105, 255, 1);
}
</style>
